module.exports = __webpack_public_path__ + "static/media/verifyYellow.4560dd38.svg";